import styled, { css, keyframes } from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { EllipsisWithLineClamp } from '@simplywallst/ui-core';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;
const onEnter = (opacity = 1) => keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: ${opacity};
  }
`;

export const Wrapper = styled('section')`
  position: relative;
  background-color: ${({ theme }) => theme.color.noir};
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  overflow: hidden;
  ${media.lgUp`
    margin-bottom: ${({ theme }) => theme.x4spacePx}px;
    border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
    border-radius: ${({ theme }) => theme.x1spacePx}px;
  `}
`;

export const Summary = styled('header')`
  background-color: ${({ theme }) => theme.color.whiteRGBA(0.02)};
  position: relative;
  padding: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    padding: ${({ theme }) => `${theme.x3spacePx}px ${theme.x4spacePx}px`};
  `}
  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 140px;
    position: absolute;
    bottom: 0;
    left: 0;
    ${({ theme }) => css`
      background: linear-gradient(
        180deg,
        ${theme.color.charcoalRGBA(0)} 0%,
        ${theme.color.charcoalRGBA(0.4)} 20%,
        ${theme.color.charcoalRGBA(0.8)} 50%,
        ${theme.color.charcoalRGBA(0.9)} 70%,
        ${theme.color.charcoalRGBA(1)} 100%
      );
    `}
  }
`;

export const Content = styled(Grid)`
  position: relative;
  z-index: 1;
`;

export const Image = styled('img')`
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 0;
  opacity: 0.2;
  transition: opacity 1s;
  animation: ${onEnter(0.2)} 0.5s ${cubicBezier};
`;

export const WatchlistToggleWrapper = styled(Grid)`
  svg {
    margin: -3px 0 0 0;
  }
`;

export const Description = styled(Grid)`
  span {
    ${EllipsisWithLineClamp(3)}
    ${media.lgUp`
      ${EllipsisWithLineClamp(2)}
    `}
  }
  button {
    opacity: 0.7;
    margin-top: 2px;
  }
`;

export const Slides = styled(Grid)`
  padding: ${({ theme }) => theme.x2spacePx}px 0;
`;

export const Slide = styled('div')`
  padding-left: ${({ theme }) => theme.x2spacePx}px;
  &:last-child {
    padding-right: ${({ theme }) => theme.x2spacePx}px;
  }
`;

export const SlideButton = styled('button')<{ align?: 'left' | 'right' }>`
  position: absolute;
  margin-top: -${({ theme }) => theme.x6spacePx / 2}px;
  top: 50%;
  padding: 12px;
  animation: ${onEnter()} 0.5s ${cubicBezier};
  background: ${({ theme }) => theme.color.spaceGray};
  width: ${({ theme }) => theme.x6spacePx}px;
  height: ${({ theme }) => theme.x6spacePx}px;
  border-radius: ${({ theme }) => theme.x6spacePx}px;
  box-shadow: 0px 5px 5px ${({ theme }) => theme.color.blackRGBA(0.4)};
  ${({ align = 'left' }) =>
    align === 'left'
      ? css`
          left: ${({ theme }) => 350 + theme.x2spacePx}px;
        `
      : css`
          right: ${({ theme }) => theme.x2spacePx}px;
        `}
  > svg > * {
    fill: ${({ theme }) => theme.color.white};
  }
  &:disabled {
    display: none;
  }
`;

export const SlideContent = styled(Grid)`
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  background-color: ${({ theme }) => theme.color.charcoal};
  height: 100%;
  padding: ${({ theme }) => `20px ${theme.x2spacePx}px ${theme.x2spacePx}px`};
`;
